import React, { useEffect, useState } from 'react';
import { onUploadsChange } from 'util/uploadGuard';

/** Shown on every page while uploads are running (task #5). */
export const UploadBanner: React.FC = () => {
  const [count, setCount] = useState(0);
  useEffect(() => onUploadsChange(setCount), []);
  if (count === 0) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        left: '50%',
        bottom: 16,
        transform: 'translateX(-50%)',
        zIndex: 1000,
        background: '#16181D',
        color: '#FFFFFF',
        borderRadius: 999,
        padding: '10px 18px',
        fontSize: 14,
        boxShadow: '0 8px 24px rgba(0,0,0,0.25)',
        whiteSpace: 'nowrap',
      }}
    >
      Uploading {count} file{count === 1 ? '' : 's'}. Keep this tab open until it finishes.
    </div>
  );
};

export default UploadBanner;
